import { IconCalendarUpdateOutline18 as UpdateIcon } from "nucleo-ui-outline-18"

import type {} from "@productlane/lib/src/tiptap/extensions/mintlify/update"

import type { SlashCommandDefinition } from "../../types"
import { iconClassName } from "../../constants"

export const updateCommand: SlashCommandDefinition = {
	key: "update",
	title: "Update",
	icon: <UpdateIcon strokeWidth={1.75} className={iconClassName} />,
	command: ({ editor, range }) => {
		editor.chain().focus().deleteRange(range).insertUpdate().run()
	},
	group: "blocks",
	aliases: ["update", "changelog", "release", "release notes", "version"],
}
